import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { options } from 'config/reactRedux';
import createGetTranslation from 'selectors/i18n';

const I18n = ({ getTranslation, field, defaultText }) => (
  <span>{getTranslation(field, defaultText)}</span>
);

I18n.propTypes = {
  field: PropTypes.string.isRequired,
  defaultText: PropTypes.string.isRequired,
  getTranslation: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  getTranslation: createGetTranslation(state),
});

const withRedux = connect(
  mapStateToProps,
  undefined,
  undefined,
  options,
);

export default withRedux(I18n);
